import { render } from "./AnnualActions.vue?vue&type=template&id=00be12da&scoped=true"
import script from "./AnnualActions.vue?vue&type=script&lang=js"
export * from "./AnnualActions.vue?vue&type=script&lang=js"

import "./AnnualActions.vue?vue&type=style&index=0&id=00be12da&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00be12da"]])

export default __exports__